import axios from 'axios'
import ls from 'local-storage'
import { JSONtoURL } from '../helpers';

const API_URL = 'https://taskmgr.info/api/'

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    common:{
      'Authorization': 'Bearer ' + (ls('user') && ls('user').token)
    }    
  }
})

export default {
    axios: axiosInstance,
    setToken(token){
      return this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    },
    async get(path, params){
      const res = await this.axios.get(params ? `${path}?${JSONtoURL(params)}` : path)
      if(res && res.data && (res.data.status == "error")){
        throw res.data.message    
      }      
      return res    
    },
    async post(path, params){
      const res = await this.axios.post(path, JSONtoURL(params))
      if(res && res.data && (res.data.status == "error")){
        throw res.data.message    
      }      
      return res          
    },
    async postFormData(path, formData) {
      const res = await this.axios.post(path, formData)
      if (res && res.data && (res.data.status === 'error')) {
        throw res.data.message
      }
      return res
    },
    async put(path, params){
      const res = await this.axios.put(path, JSONtoURL(params))
      if(res && res.data && (res.data.status == "error")){
        throw res.data.message    
      }      
      return res          
    },
    async delete(path, params){
      const res = await this.axios.delete(path, JSONtoURL(params))
      if(res && res.data && (res.data.status == "error")){
        throw res.data.message    
      }      
      return res   
    },
    async postJSON(path, params){
      const res = await this.axios.post(path, params, {headers:{'Content-Type': 'application/json'}})
      if(res && res.data && (res.data.status == "error")){
        throw res.data.message    
      }      
      return res          
    },
    async putJSON(path, params){
      const res = await this.axios.put(path, params, {headers:{'Content-Type': 'application/json'}})
      if(res && res.data && (res.data.status == "error")){
        throw res.data.message    
      }      
      return res          
    },

}